import React from 'react';
import { Link } from 'react-router-dom';
import Nav from '../components/Nav';
import useSEO from '../common/useSEO';

export default function Contact() {
  useSEO({
    title: 'CONTACT — Aaron Figueroa',
    description: 'Book a recording session or discuss video production with Aaron Figueroa. In-studio at Bay Area Podcast Studio and on-location across the Bay Area, CA.',
    path: '/contact'
  });

  return (
    <div className="min-h-screen bg-[#000000] text-[#FFFFFF] font-sans selection:bg-[#FFFFFF] selection:text-[#000000]">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
        <Nav />

        <main
          className="w-full flex flex-col items-center"
          style={{ paddingTop: '4rem', paddingBottom: '6rem' }}
        >
          <div className="w-full max-w-[800px] mx-auto">

            {/* Header */}
            <h1
              className="contact-heading font-bold uppercase text-[#FFFFFF] text-center"
              style={{
                fontSize: 'clamp(2rem, 3vw, 2.8rem)',
                fontWeight: 700,
                letterSpacing: '-0.01em',
                lineHeight: 1.1,
                marginBottom: '2.5rem',
              }}
            >
              GET IN TOUCH
            </h1>

            {/* Direct Form Robin Iframe Embed */}
            <div
              className="contact-form w-full rounded-md overflow-hidden"
              style={{ minHeight: '600px', width: '100%' }}
            >
              <iframe
                src="https://formrobin.com/f/3p900lw"
                width="100%"
                height="600"
                style={{ border: 'none', background: 'transparent' }}
                title="Contact Form"
                allow="microphone; camera"
              ></iframe>
            </div>

          </div>
        </main>

        {/* Contact-specific footer */}
        <footer
          className="w-full flex justify-center items-center"
          style={{
            borderTop: '1px solid #1F1F1F',
            paddingTop: '4rem',
            paddingBottom: '4rem',
          }}
        >
          <div className="flex flex-wrap justify-center items-center gap-3 text-[0.75rem] uppercase tracking-[0.1em] text-[#666666]">
            <span>© 2026 AARON FIGUEROA</span>
            <span>•</span>
            <Link
              to="/privacy"
              className="transition-colors duration-300 hover:text-[#FFFFFF]"
            >
              PRIVACY
            </Link>
            <span>•</span>
            <a
              href="#"
              onClick={(e) => e.preventDefault()}
              className="transition-colors duration-300 hover:text-[#FFFFFF]"
            >
              ACCESSIBILITY
            </a>
          </div>
        </footer>
      </div>
    </div>
  );
}